var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "goods-edit" } },
    [
      _c("breadcrumb-top", { attrs: { breadcrumbConfig: _vm.dataList } }),
      _c(
        "div",
        { staticClass: "content c-top" },
        [
          _c("breadcrumb-search", {
            attrs: { breadcrumbSearch: _vm.searchList },
          }),
          _c(
            "el-form",
            {
              ref: "infoForm",
              staticClass: "info-form",
              staticStyle: { "margin-top": "22px" },
              attrs: { "label-width": "110px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "优惠券名称" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "232px" },
                    attrs: {
                      size: "small",
                      placeholder: "请输入优惠券名称",
                      disabled: "",
                    },
                    model: {
                      value: _vm.detail.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.detail, "name", $$v)
                      },
                      expression: "detail.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "优惠券优惠金额" } },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "232px" },
                      attrs: { disabled: "", size: "small" },
                      model: {
                        value: _vm.detail.price,
                        callback: function ($$v) {
                          _vm.$set(_vm.detail, "price", $$v)
                        },
                        expression: "detail.price",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "margin-right": "8px" },
                          attrs: { slot: "suffix" },
                          slot: "suffix",
                        },
                        [_vm._v("元")]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "最低满足金额" } },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "232px" },
                      attrs: { disabled: "", size: "small" },
                      model: {
                        value: _vm.detail.minPrice,
                        callback: function ($$v) {
                          _vm.$set(_vm.detail, "minPrice", $$v)
                        },
                        expression: "detail.minPrice",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "margin-right": "8px" },
                          attrs: { slot: "suffix" },
                          slot: "suffix",
                        },
                        [_vm._v("元")]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "起止时间" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "232px" },
                    attrs: {
                      disabled: "",
                      size: "small",
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      "default-time": ["00:00:00", "23:59:59"],
                    },
                    model: {
                      value: _vm.startTime,
                      callback: function ($$v) {
                        _vm.startTime = $$v
                      },
                      expression: "startTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "有效时间" } },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "232px" },
                      attrs: { disabled: "", size: "small" },
                      model: {
                        value: _vm.detail.expireDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.detail, "expireDate", $$v)
                        },
                        expression: "detail.expireDate",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "margin-right": "8px" },
                          attrs: { slot: "suffix" },
                          slot: "suffix",
                        },
                        [_vm._v("天")]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "优惠券内容说明" } }, [
                _c("div", { staticClass: "detail" }, [
                  _vm._v(_vm._s(_vm.detail.couponText)),
                ]),
              ]),
              _c("el-form-item", { attrs: { label: "会员状态" } }, [
                _c("div", { staticStyle: { display: "flex" } }, [
                  _c("div", {
                    class: _vm.detail.status == 1 ? "start" : "end",
                  }),
                  _vm.detail.status == 1
                    ? _c("div", { staticClass: "s-label" }, [_vm._v("已启用")])
                    : _c("div", { staticClass: "s-label" }, [_vm._v("已禁用")]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "back-btn" },
        [
          _c(
            "el-button",
            { attrs: { type: "info" }, on: { click: _vm.back } },
            [_vm._v("返回")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }